import React from "react";
import * as S from "./Button.styles";

type ButtonProps = {
  text?: string;
  color?: string;
  textColor?: string;
  hovercolor?: string;
  icon?: React.ReactElement;
  lowericon?: React.ReactElement;
  hoverColor?: string;
  size?: string;
  href?: string;
};

export const Button = ({
  text,
  color,
  hovercolor,
  icon,
  lowericon,
  textColor,
  size,
  href = "https://wa.link/netv6h",
}: ButtonProps) => {
  return (
    <S.Button
      target="_blank"
      href={lowericon ? undefined : href}
      color={color}
      $hovercolor={hovercolor}
      $lowericon={lowericon}
      textColor={textColor}
      size={size}
    >
      {icon}
      <p>{text ? text : "Agendar consulta"}</p>
      {lowericon}
    </S.Button>
  );
};
